<template>
  <div>
    <app-layout class="app-layout" :hasFooter="true" :hasHeader="false" :centerMd="12">
      <div slot="layout-body" class="container h-100 d-flex justify-content-center">
        <div class="wake-lock" v-if="isWakeLockAPICompatible && !isLocalDBComplete">
          <img :src="require('@/assets/WAKE_LOCKED_WHITE.png')" />
        </div>
        <b-card class="m-5 p-5" style="border-radius: 25px; color: #9175a4; font-weight: bold"
          :img-src="require('@/assets/home/XL_LOGO_INOE_MOBI_BULLE.svg')" title="Synchronisation des données">
          <b-card-text v-if="!isLocalDBComplete || !isMemDBLoaded">
            <b-spinner small type="grow" variant="danger"></b-spinner>
            <div class="d-flex justify-content-center align-content-center">
              <p>
                <em class="blockquote-footer" v-if="getInterval === 0">Calcul de la durée approximative de la
                  synchronisation
                  ...</em>
                <em class="blockquote-footer" v-else-if="getProgress < getMaxDbSize">Synchronisation complète estimée à
                  ≈
                  {{ minutesRestantes }} mins.
                  <b-badge class="d-block m-2" v-if="isNetworkAPICompatible && ect !== -1" :variant="
                      ect == 0 ? 'success' : ect == 1 ? 'warning' : 'danger'
                    ">{{ connextion[ect] }} ≈ {{ networkSpeed }} Mb/s</b-badge>
                </em>
                <em v-else> Finalisation ...</em>
                <b-progress :max="getMaxDbSize">
                  <b-progress-bar :value="getProgress" :label="`${((getProgress / getMaxDbSize) * 100).toFixed(
                      2
                    )}%`"></b-progress-bar>
                </b-progress>
              </p>
            </div>
          </b-card-text>
          <b-card-text class="mb-3 mt-3">
            <b-list-group>
              <b-list-group-item>
                Synchronisation des données...
                <b-badge v-if="!isLocalDBComplete" variant="warning" pill>En cours...
                </b-badge>
                <b-badge v-if="isLocalDBComplete" variant="success" pill>terminée !</b-badge>
                <div v-else>
                  <button class="btn btn-warning txt-bold" @click="skipSync">Passer cette étape ></button>

                </div>


                <!-- <b-badge v-if="getLocalDBStatus === 'empty'" variant="warning" pill>Vide</b-badge> -->
              </b-list-group-item>
              <b-list-group-item>
                Initialisation de l'application
                <b-badge v-if="getMemDBStatus === 'loaded'" variant="success" pill>terminée !</b-badge>
                <b-badge v-if="getMemDBStatus === 'empty'" variant="warning" pill>Vide</b-badge>
                <b-badge v-if="getMemDBStatus === 'error'" variant="danger" pill>Echec</b-badge>
                <b-badge v-if="getMemDBStatus === 'loading'" variant="warning" pill>En cours...</b-badge>
              </b-list-group-item>
            </b-list-group>
          </b-card-text>
          <b-button v-if="isUpgrading && isLocalDBComplete && isMemDBLoaded" variant="success" @click="maj()">
            Mettre à jour l'application
          </b-button>
          <b-button @click="suivant" variant="success" v-else-if="isLocalDBComplete && isMemDBLoaded">Entrer dans Mobi
            ></b-button>
          <br />
          <span v-if="getMemDBStatus === 'error'" class="text-danger">Aucune activité n'a été trouvée pour cet
            utilisateur. Veuillez
            vérifier votre paramétrage</span>
        </b-card>
      </div>
    </app-layout>
  </div>
</template>

<script>
import AppLayout from "@/components/app-layout.vue";
import store from "@/store";

import $inoe from "@/config";
import router from "@/router/";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { AppLayout },
  mounted() {
    store.dispatch("session/sync");
  },
  data() {
    return {
      minutesRestantes: 0,
      networkSpeed: 0,
      ect: -1,
      connextion: ["Bon débit", "Débit moyen", "Débit très faible"],
      wakeLockApi: null,
      isWakeLockAPICompatible: $inoe.isWakeLockAPICompatible(),
      isNetworkAPICompatible: $inoe.isNetWorkAPICompatible(),
    };
  },
  created() {
    this.updateConnectionStatus();
    this.requestWakeLock();
  },
  computed: {
    ...mapGetters("session", [
      "isLocalDBComplete",
      "getLocalDBStatus",
      "getMemDBStatus",
      "getMemDBStats",
      "isAuthenticated",
      "getProgress",
      "getMaxDbSize",
      "getInterval",
    ]),

    isMemDBLoaded() {
      return this.getMemDBStatus === "loaded";
    },
    isUpgrading: function () {
      return $inoe.isUpgrading();
    }
  },
  watch: {
    isLocalDBPaused(newval, oldval) {
      if (!oldval && newval) {
        //this.reloadMemDB();
      }
    },
    getInterval(newval, oldval) {
      if (newval !== 0 && oldval === 0) {
        /**
         * getInterval : Temps en secondes pour télécharger 5000 documents
         * minutesRestantes : Temps en minutes pour télécharger toute la DB
         */
        this.minutesRestantes = Math.floor(
          (newval * this.getMaxDbSize) / (5000 * 60)
        );
        this.updateConnectionStatus();
        console.log("Calcul de la durée ...", this.minutesRestantes);
      }
    },
    minutesRestantes: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.minutesRestantes--;
          }, 59000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    isLocalDBComplete(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.wakeLockApi.release();
        console.log("Releasing WakeLock API", this.wakeLockApi);
        this.wakeLockApi = null;
      }
    },
    getProgress(newval, oldval){
      console.log(newval)
      this.updateConnectionStatus()
    }
  },

  methods: {
    ...mapActions (
      {skipSync:"session/skipSync"}
    ),
    reloadMemDB() {
      store.dispatch("session/loadMemDB");
    },
    suivant() {
      router.push("/etablissements");
    },
    updateConnectionStatus(event) {
      console.log("updateConnectionStatus");
      if (
        "connection" in navigator &&
        "downlink" in navigator.connection &&
        "effectiveType" in navigator.connection
      ) {
        $inoe.setNetWorkAPICompatible(true);
        this.networkSpeed = navigator.connection.downlink;
        this.ect =
          navigator.connection.effectiveType === "4g"
            ? 0
            : navigator.connection.effectiveType === "3g" ||
              navigator.connection.effectiveType === "2g"
            ? 1
            : 2;
      } else $inoe.setNetWorkAPICompatible(false);
    },
    requestWakeLock() {
      if ("wakeLock" in navigator)
        navigator.wakeLock
          .request("screen")
          .then((rep) => {
            console.log("requestWakeLock API", rep);
            $inoe.setWakeLockAPICompatible(true);
            this.wakeLockApi = rep;
          })
          .catch((error) =>
            console.error("Empecher la mise en veille : échec", error)
          );
      else $inoe.setWakeLockAPICompatible(false);
    },
    maj() {
      console.log("maj")
      store
        .dispatch("parametres/fetchPointagesLocal")
    }  
  },
};
</script>

<style scoped>
.progress-bar {
  background-color: #663682 !important;
}
.wake-lock {
  height: 30px;
  display: flex;
  font-size: 10px;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  top: 1%;
}
.wake-lock img {
  width: 30px;
}
</style>
